import type React from "react";

import styled from "styled-components";

import { useVideoCallContext } from "contexts/VideoCallContext";

interface ContainerProps {
  $expandMargin: boolean;
}

const Container = styled.div<ContainerProps>`
  margin-left: auto;
  margin-right: auto;
`;

interface Props {
  readonly children?: React.ReactNode;
  readonly className?: string;
  readonly dataTestId?: string;
}

export const VideoCallAwareContainer: React.FC<Props> = ({ children, className, dataTestId }) => {
  const { callData, videoCallMode } = useVideoCallContext();

  return (
    <Container
      $expandMargin={callData !== null && videoCallMode === "docked"}
      className={className}
      data-testid={dataTestId}
    >
      {children}
    </Container>
  );
};
